import { useEffect } from 'react';
import { useDeckStorage } from '@/hooks/use-deck-storage';
import { useToast } from '@/hooks/use-toast';
import { Capacitor } from '@capacitor/core';

export function DeckStorageInitializer() {
  const { hasLocalStorage, error } = useDeckStorage();
  const { toast } = useToast();

  // Show error if there's an issue initializing deck storage
  useEffect(() => {
    if (error && Capacitor.isNativePlatform()) {
      console.error('Deck storage initialization error:', error);
      toast({
        title: 'Storage Initialization Error',
        description: 'There was a problem preparing the card decks for offline use.',
        variant: 'destructive',
      });
    }
  }, [error, toast]);

  // This component doesn't render anything, it just initializes the deck storage
  return null;
}